import { MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

import { buildHyper3dImageTo3dGen2FromState } from './Utils/buildHyper3dImageTo3dGen2FromState'
import { buildHyper3dRetextureProFromState } from './Utils/buildHyper3dRetextureProFromState'
import { buildHyper3dTextTo3dGen2FromState } from './Utils/buildHyper3dTextTo3dGen2FromState'
import { buildMeshyImageTo3dProFromState } from './Utils/buildMeshyImageTo3dProFromState'
import { buildMeshyMeshSimplificationProFromState } from './Utils/buildMeshyMeshSimplificationProFromState'
import { buildMeshyRetextureProFromState } from './Utils/buildMeshyRetextureProFromState'
import { buildMeshyTextTo3dProFromState } from './Utils/buildMeshyTextTo3dProFromState'
import { buildTencentImageTo3dProFromState } from './Utils/buildTencentImageTo3dProFromState'
import { buildTencentMeshSegmentationProFromState } from './Utils/buildTencentMeshSegmentationProFromState'
import { buildTencentMeshSimplificationProFromState } from './Utils/buildTencentMeshSimplificationProFromState'
import { buildTencentRetextureProFromState } from './Utils/buildTencentRetextureProFromState'
import { buildTencentTextTo3dProFromState } from './Utils/buildTencentTextTo3dProFromState'
import { buildTripo3dImageTo3dDefaultFromState } from './Utils/buildTripo3dImageTo3dDefaultFromState'
import { buildTripo3dMeshSegmentationDefaultFromState } from './Utils/buildTripo3dMeshSegmentationDefaultFromState'
import { buildTripo3dMeshSimplificationDefaultFromState } from './Utils/buildTripo3dMeshSimplificationDefaultFromState'
import { buildTripo3dRetextureDefaultFromState } from './Utils/buildTripo3dRetextureDefaultFromState'
import { buildTripo3dTextTo3dDefaultFromState } from './Utils/buildTripo3dTextTo3dDefaultFromState'

const BUILDERS = {
  [MODEL_ID.TENCENT_IMAGE_TO_3D_PRO]: buildTencentImageTo3dProFromState,
  [MODEL_ID.TENCENT_TEXT_TO_3D_PRO]: buildTencentTextTo3dProFromState,
  [MODEL_ID.TENCENT_MESH_SIMPLIFICATION_PRO]: buildTencentMeshSimplificationProFromState,
  [MODEL_ID.TENCENT_MESH_SEGMENTATION_PRO]: buildTencentMeshSegmentationProFromState,
  [MODEL_ID.TENCENT_RETEXTURE_PRO]: buildTencentRetextureProFromState,
  [MODEL_ID.TRIPO3D_IMAGE_TO_3D_DEFAULT]: buildTripo3dImageTo3dDefaultFromState,
  [MODEL_ID.TRIPO3D_TEXT_TO_3D_DEFAULT]: buildTripo3dTextTo3dDefaultFromState,
  [MODEL_ID.TRIPO3D_RETEXTURE_DEFAULT]: buildTripo3dRetextureDefaultFromState,
  [MODEL_ID.MESHY_TEXT_TO_3D_PRO]: buildMeshyTextTo3dProFromState,
  [MODEL_ID.MESHY_IMAGE_TO_3D_PRO]: buildMeshyImageTo3dProFromState,
  [MODEL_ID.MESHY_RETEXTURE_PRO]: buildMeshyRetextureProFromState,
  [MODEL_ID.MESHY_MESH_SIMPLIFICATION_PRO]: buildMeshyMeshSimplificationProFromState,
  [MODEL_ID.TRIPO3D_MESH_SIMPLIFICATION_DEFAULT]: buildTripo3dMeshSimplificationDefaultFromState,
  [MODEL_ID.TRIPO3D_MESH_SEGMENTATION_DEFAULT]: buildTripo3dMeshSegmentationDefaultFromState,
  [MODEL_ID.HYPER3D_TEXT_TO_3D_GEN2]: buildHyper3dTextTo3dGen2FromState,
  [MODEL_ID.HYPER3D_IMAGE_TO_3D_GEN2]: buildHyper3dImageTo3dGen2FromState,
  [MODEL_ID.HYPER3D_RETEXTURE_PRO]: buildHyper3dRetextureProFromState,
}

/**
 * Builds an openedModel-shaped object from the current store state and run id,
 * dispatching by state.schema.generationModelSchema.model_id so the result is
 * the inverse of the matching openedModelToStatePatch parser. Used so
 * lastGenerationSettings can be passed to setOpenedModel without an extra
 * API round-trip.
 *
 * Returns `{ id }` (no providerModelId) when the model_id is missing or
 * unrecognized; openedModelToStatePatch then resets state to defaults.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by openedModelToStatePatch
 */
export const buildOpenedModelFromState = (state, id) => {
  const modelId = state?.schema?.generationModelSchema?.model_id
  const builder = BUILDERS[modelId]
  if (!builder) {
    return { id }
  }

  return builder(state, id)
}
